const initBlock = async function( $block ) {
	const { Swiper } = await import( 'swiper' );
	const { Navigation, Pagination } = await import( 'swiper/modules' );
	await import( 'swiper/css/bundle' );

	const $sliderWrap = $block.find( '.history-slider' );
	const $slider = $sliderWrap.find( '.history-slider__main' );
	const $paginationWrap = $sliderWrap.find( '.history-slider__pagination-wrap' );
	const $pagination = $sliderWrap.find( '.history-slider__pagination' );
	const $navigation = $sliderWrap.find( '.slider-nav__inner' );
	const $indicator = $( '<div class="pagination-indicator"></div>' );

	const updateIndicator = () => {
		const $activeBullet = $pagination.find( '.pagination-bullet-active' );

		if ( $activeBullet.length > 0 ) {
			const bulletOffset = $activeBullet.position().left;
			const bulletWidth = $activeBullet.outerWidth();

			$indicator.css( {
				width: bulletWidth + 'px',
				transform: 'translateX(' + bulletOffset + 'px)'
			} );

			if ( $( window ).width() <= 860 ) {
				$paginationWrap[0].scrollTo( {
					left: bulletOffset - $paginationWrap.width() / 2 + bulletWidth / 2,
					behavior: 'smooth'
				} );
			}
		} else {
			console.warn( 'No active bullet found' );
		}
	};

	const swiperHistoryParams = {
		modules: [Navigation, Pagination],
		navigation: {
			nextEl: $navigation.find( '.slider-arrow--next' )[0],
			prevEl: $navigation.find( '.slider-arrow--prev' )[0]
		},
		pagination: {
			el: $pagination[0],
			type: 'bullets',
			renderBullet: function( index, className ) {
				return '<span class="' + className + '"><span class="label">' + ( index + 1 ).toString().padStart( 2, '0' ) + '</span></span>';
			},
			bulletClass: 'pagination-bullet',
			bulletActiveClass: 'pagination-bullet-active',
			clickable: true
		},
		init: false,
		loop: false,
		allowTouchMove: false,
		speed: 750,
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerGroup: 1,
		breakpoints: {
			767: {
				slidesPerView: 'auto',
			}
		},
		on: {
			slideChange: function() {
				updateIndicator();
			},
			init: function() {
				const totalSlides = this.slides.length;
				$pagination.attr( 'data-slides-count', totalSlides );
				$pagination.append( $indicator );
				updateIndicator();
				$indicator.css( 'transition', 'transform 0.75s ease' );

				if ( totalSlides > 2 ) {
					$paginationWrap.addClass( 'pagination-modifier' );
				}

				$pagination.find( '.pagination-bullet' ).on( 'click', function() {
					if ( $( window ).width() <= 860 ) {
						const $bullet = $( this );
						$paginationWrap[0].scrollTo( {
							left: $bullet[0].offsetLeft,
							behavior: 'smooth'
						} );
					}
				} );
			}
		}
	};
	const swiperHistory = new Swiper( $slider[0], swiperHistoryParams );
	swiperHistory.init();

	$( window ).on( 'resize', updateIndicator );
};

themeUtils.loadBlock( initBlock, 'history-slider', '.section-history-slider' );
